export const GET_TESTIMONIAL = "GET_TESTIMONIAL";
export const GET_TESTIMONIAL_RESPONSE = "GET_TESTIMONIAL_RESPONSE";
export const TESTIMONIAL_LOADER_STATUS_UPDATE =
  "TESTIMONIAL_LOADER_STATUS_UPDATE";
